const BASE_PT = 9.5;
const MIN_PT = 7;
const MAX_PT = 14;
const GAP_MM = 8;

const esc = (s) => String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

const SEZIONI = [
  ['CHAMPAGNE', t => t === 'champagne'],
  ['BOLLICINE', t => ['bollicine', 'spumante', 'prosecco', 'franciacorta'].includes(t)],
  ['VINI BIANCHI', t => ['bianco', 'white'].includes(t)],
  ['VINI ROSATI', t => ['rosato', 'rose', 'rosé'].includes(t)],
  ['VINI ROSSI', t => ['rosso', 'red'].includes(t)],
  ['VINI DOLCI E PASSITI', t => ['dolce', 'passito', 'sweet'].includes(t)],
];

const raggruppaPerTipo = (vini) => {
  const gruppi = SEZIONI.map(([titolo]) => [titolo, []]);
  const altro = [];
  vini.forEach(v => {
    const tipo = (v.tipo_vino || 'altro').toLowerCase();
    const idx = SEZIONI.findIndex(([, match]) => match(tipo));
    (idx >= 0 ? gruppi[idx][1] : altro).push(v);
  });
  gruppi.push(['ALTRI VINI', altro]);
  return gruppi.filter(([, lista]) => lista.length);
};

const perChiave = (lista, keyFn) => {
  const gruppi = {};
  lista.forEach(v => { const k = keyFn(v); (gruppi[k] = gruppi[k] || []).push(v); });
  return Object.entries(gruppi).sort((a, b) => a[0].localeCompare(b[0]));
};

const ordinaPerNome = (lista) => [...lista].sort((a, b) => (a.nome || '').localeCompare(b.nome || ''));

const rigaVino = (vino, s) => {
  let nome = esc((vino.nome || 'Vino').toUpperCase());
  if (vino.annata && String(vino.annata).match(/^(19|20)\d{2}$/)) nome += ' ' + vino.annata;
  if (s.mostraFormato && vino.formato) nome += ' - ' + esc(String(vino.formato).toUpperCase());
  let html = '<div class="it vino-block"><div class="vino"><div class="nome-wrap"><span class="nome">' + nome + '</span></div><span class="dots"></span>';
  if (s.mostraPrezzi && vino.prezzo_vendita) html += '<span class="prezzo">' + Number(vino.prezzo_vendita).toFixed(0) + '</span>';
  html += '</div>';
  if (vino.cantina) html += '<div class="cantina-row">' + esc([vino.cantina, vino.regione].filter(Boolean).join(' — ')) + '</div>';
  if (s.mostraDescrizione) {
    const info = [vino.vitigno, vino.gradazione].filter(Boolean).map(i => esc(String(i).toUpperCase())).join(' • ');
    if (info) html += '<div class="info">' + info + '</div>';
    if (vino.descrizione) html += '<div class="desc">' + esc(String(vino.descrizione).toUpperCase()) + '</div>';
    if (vino.abbinamenti) html += '<div class="abbinamenti">ABBINAMENTI: ' + esc(String(vino.abbinamenti).toUpperCase()) + '</div>';
  }
  if (vino.riconoscimenti) html += '<div class="riconoscimenti">★ ' + esc(String(vino.riconoscimenti).toUpperCase()) + '</div>';
  return html + '</div>';
};

const itemsVini = (vini, s) => {
  let html = '';
  raggruppaPerTipo(vini).forEach(([titolo, lista]) => {
    html += '<div class="it sez" data-kw="1"><h2>' + titolo + '</h2></div>';
    perChiave(lista, v => v.regione || v.nazione || 'Altro').forEach(([regione, viniRegione]) => {
      html += '<div class="it reg" data-kw="1"><h3>' + esc(regione.toUpperCase()) + '</h3></div>';
      ordinaPerNome(viniRegione).forEach(v => { html += rigaVino(v, s); });
    });
  });
  return html;
};

const prezzoLiquore = (l) => (l.prezzo_menu > 0 ? l.prezzo_menu : l.prezzo_acquisto > 0 ? Math.ceil(l.prezzo_acquisto / 8) : null);

const itemsLiquori = (liquori) => {
  const lista = liquori.filter(l => l.includi_stampa !== false);
  if (!lista.length) return '';
  let html = '<div class="it sez liq" data-kw="1"><h2>LIQUORI E DISTILLATI</h2><p class="subtitle">Prezzo al bicchiere</p></div>';
  perChiave(lista, l => l.categoria || 'Altro').forEach(([cat, items]) => {
    html += '<div class="it reg" data-kw="1"><h3>' + esc(cat.toUpperCase()) + '</h3></div>';
    ordinaPerNome(items).forEach(l => {
      const prezzo = prezzoLiquore(l);
      html += '<div class="it vino-block"><div class="vino"><div class="nome-wrap"><span class="nome">' + esc(l.nome) + '</span></div><span class="dots"></span>'
        + (prezzo ? '<span class="prezzo">' + Number(prezzo).toFixed(0) + '</span>' : '') + '</div></div>';
    });
  });
  return html;
};

// Eseguito dentro la finestra di stampa (serializzato con toString: nessun riferimento esterno, solo ES5)
function impaginaScript() {
  var cfg = window.__CFG;
  var MM = 96 / 25.4;
  var limite = (cfg.H - 3) * MM;
  var measure = document.getElementById('measure');
  var pages = document.getElementById('pages');
  var lista = function (sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); };
  var vini = lista('#src-vini .it');
  var liq = lista('#src-liq .it');

  function pack(items, fontPt, lim) {
    measure.style.fontSize = fontPt.toFixed(2) + 'pt';
    for (var i = 0; i < items.length; i++) measure.appendChild(items[i]);
    var hs = items.map(function (el) { return el.getBoundingClientRect().height; });
    var cols = [], cur = [], usato = 0;
    for (var k = 0; k < items.length; k++) {
      var serve = hs[k];
      if (items[k].getAttribute('data-kw')) {
        for (var j = k + 1; j < items.length; j++) { serve += hs[j]; if (!items[j].getAttribute('data-kw')) break; }
      }
      if (cur.length && usato + serve > lim) { cols.push(cur); cur = []; usato = 0; }
      cur.push(items[k]); usato += hs[k];
    }
    if (cur.length) cols.push(cur);
    return cols;
  }
  var pagine = function (cols) { return Math.ceil(cols.length / 2); };

  var font = cfg.basePt, lim = limite, avviso = '';
  if (vini.length && cfg.target > 0) {
    var lo = cfg.minPt, hi = cfg.maxPt;
    var pagMin = pagine(pack(vini, lo, limite));
    if (pagMin > cfg.target) {
      font = lo;
      avviso = 'Impossibile stare in ' + cfg.target + ' pagine: anche al font minimo (' + lo + 'pt) i vini occupano ' + pagMin + ' pagine. Stampo su ' + pagMin + '.';
    } else if (pagine(pack(vini, hi, limite)) <= cfg.target) {
      font = hi;
      var lLo = 0, lHi = limite;
      for (var a = 0; a < 16; a++) {
        var mid = (lLo + lHi) / 2;
        if (pagine(pack(vini, hi, mid)) <= cfg.target) lHi = mid; else lLo = mid;
      }
      lim = lHi;
    } else {
      for (var b = 0; b < 14; b++) {
        var m = (lo + hi) / 2;
        if (pagine(pack(vini, m, limite)) <= cfg.target) lo = m; else hi = m;
      }
      font = lo;
    }
  }

  function build(cols, fontPt) {
    for (var p = 0; p < cols.length; p += 2) {
      var page = document.createElement('div');
      page.className = 'page';
      page.style.fontSize = fontPt.toFixed(2) + 'pt';
      for (var c = p; c < p + 2; c++) {
        var col = document.createElement('div');
        col.className = 'col';
        if (cols[c]) for (var i = 0; i < cols[c].length; i++) col.appendChild(cols[c][i]);
        page.appendChild(col);
      }
      pages.appendChild(page);
    }
    return Math.ceil(cols.length / 2);
  }

  var nVini = vini.length ? build(pack(vini, font, lim), font) : 0;
  var nLiq = liq.length ? build(pack(liq, font, limite), font) : 0;
  var tot = (cfg.cover ? 1 : 0) + nVini + nLiq;
  var parti = [];
  if (cfg.cover) parti.push('copertina 1');
  if (nVini) parti.push('vini ' + nVini);
  if (nLiq) parti.push('liquori ' + nLiq);
  document.getElementById('info').textContent = tot + ' pagine (' + parti.join(' + ') + ') · font ' + font.toFixed(1) + 'pt';
  var w = document.getElementById('avviso');
  if (avviso) { w.textContent = avviso; w.style.display = 'inline-block'; }
  measure.parentNode.removeChild(measure);
  ['src-vini', 'src-liq'].forEach(function (id) { var el = document.getElementById(id); if (el) el.parentNode.removeChild(el); });
  window.__RISULTATO = { pagineVini: nVini, pagineLiquori: nLiq, totale: tot, font: font, avviso: avviso, target: cfg.target };
}

export const buildCartaViniHtml = (viniDaStampare, liquori, s) => {
  const margLat = s.margineLat || 10;
  const margSup = s.margineSup || 15;
  const margInf = s.margineInf || 15;
  const W = 210 - margLat * 2;
  const H = 297 - margSup - margInf;
  const colW = (W - GAP_MM) / 2;
  const cfg = { W, H, target: parseInt(s.numeroPagine) || 0, basePt: BASE_PT, minPt: MIN_PT, maxPt: MAX_PT, cover: !!s.mostraCopertina };

  const srcVini = s.soloLiquori ? '' : itemsVini(viniDaStampare, s);
  const srcLiq = (s.mostraLiquori || s.soloLiquori) ? itemsLiquori(liquori) : '';
  const cover = s.mostraCopertina
    ? '<div class="page cover">' + (s.nomeRistorante ? '<p class="rist">' + esc(s.nomeRistorante) + '</p>' : '') + '<h1>Carta dei Vini</h1><p class="sub">WINE LIST</p></div>'
    : '';

  const css =
    '@page{size:A4;margin:' + margSup + 'mm ' + margLat + 'mm ' + margInf + 'mm ' + margLat + 'mm}' +
    '*{margin:0;padding:0;box-sizing:border-box}' +
    'html,body{margin:0;padding:0}' +
    'body{font-family:Georgia,serif;font-size:' + BASE_PT + 'pt;line-height:1.25;color:#1a1a1a;background:#fff;-webkit-print-color-adjust:exact;print-color-adjust:exact}' +
    '#measure{position:absolute;left:-9999px;top:0;width:' + colW + 'mm;visibility:hidden}' +
    '#src-vini,#src-liq{display:none}' +
    '.page{display:flex;gap:' + GAP_MM + 'mm;overflow:hidden;position:relative;break-after:page;page-break-after:always}' +
    '.page:last-child{break-after:auto;page-break-after:auto}' +
    '.col{width:' + colW + 'mm;flex:none;min-width:0;overflow:hidden}' +
    '.page.cover{flex-direction:column;justify-content:center;align-items:center;text-align:center}' +
    '.cover h1{font-size:32pt;font-weight:400;letter-spacing:6px;text-transform:uppercase;color:#8b4513}' +
    '.cover .sub{font-size:16pt;letter-spacing:4px;color:#5c3317;margin-top:15px}' +
    '.cover .rist{font-size:12pt;letter-spacing:2px;color:#8b4513;margin-bottom:30px}' +
    '.it{width:100%}' +
    '.sez{padding:0.5em 0 0.3em}' +
    '.sez h2{font-size:1.37em;font-weight:500;letter-spacing:1px;text-transform:uppercase;color:#6b4423;text-align:center;padding:0.35em 0;border-bottom:1px solid #c9a574}' +
    '.sez.liq h2{color:#5c3317;border-color:#5c3317}' +
    '.sez .subtitle{text-align:center;font-size:0.85em;color:#888;padding-top:0.3em}' +
    '.reg{padding:0.35em 0 0.2em}' +
    '.reg h3{font-size:0.95em;font-weight:600;color:#8b4513;padding-bottom:1px;border-bottom:1px dotted #d4a574}' +
    '.vino-block{padding:0.2em 0 0.25em}' +
    '.vino{display:flex;align-items:baseline;gap:4px}' +
    '.vino .nome-wrap{flex:0 1 auto;min-width:0;display:flex;align-items:baseline}' +
    '.vino .nome{font-weight:600;text-transform:uppercase}' +
    '.vino .dots{flex:1;border-bottom:1px dotted #ccc;min-width:10px;margin:0 4px;height:0;align-self:baseline;position:relative;top:-3px}' +
    '.vino .prezzo{font-weight:700;color:#5c3317;white-space:nowrap;flex-shrink:0}' +
    '.cantina-row{font-size:0.82em;color:#8b4513;font-style:italic;padding:0 0 1px 8px}' +
    '.info{font-size:0.82em;color:#666;font-style:italic;padding:0 0 0 8px}' +
    '.desc{font-size:0.78em;color:#555;font-style:italic;padding:1px 0 2px 8px;line-height:1.25}' +
    '.abbinamenti{font-size:0.78em;color:#2e7d32;padding:0 0 2px 8px}' +
    '.riconoscimenti{font-size:0.78em;color:#8d6e00;font-weight:600;padding:0 0 2px 8px}' +
    '.toolbar{position:fixed;top:0;left:0;right:0;z-index:10;background:#8b4513;color:#fff;padding:10px 16px;font-family:sans-serif;font-size:14px;display:flex;flex-wrap:wrap;align-items:center;gap:12px}' +
    '.toolbar button{background:#fff;color:#8b4513;border:none;padding:8px 20px;font-size:14px;font-weight:600;cursor:pointer;border-radius:6px}' +
    '.toolbar button:hover{background:#f3e7dc}' +
    '.toolbar .avviso{display:none;background:#fff3cd;color:#7a4b00;padding:4px 10px;border-radius:4px;font-size:13px}' +
    '@media screen{body{background:#e9e4da;padding:64px 12px 32px}#pages{min-width:210mm}' +
    '.page{width:210mm;height:297mm;padding:' + margSup + 'mm ' + margLat + 'mm ' + margInf + 'mm ' + margLat + 'mm;background:#fff;margin:0 auto 14px;box-shadow:0 2px 14px rgba(0,0,0,.18)}}' +
    '@media print{.toolbar{display:none}body{background:#fff;padding:0}#pages{min-width:0}' +
    '.page{width:' + W + 'mm;height:' + (H - 2) + 'mm;padding:0;margin:0;box-shadow:none}}';

  return '<!DOCTYPE html><html lang="it"><head><meta charset="UTF-8"><title>Carta dei Vini</title><style>' + css + '</style></head><body>' +
    '<div class="toolbar"><button onclick="window.print()" data-testid="stampa-btn">Stampa</button>' +
    '<span id="info" data-testid="stampa-info">Impaginazione in corso…</span>' +
    '<span id="avviso" class="avviso" data-testid="stampa-avviso"></span></div>' +
    '<div id="measure"></div>' +
    '<div id="src-vini">' + srcVini + '</div>' +
    '<div id="src-liq">' + srcLiq + '</div>' +
    '<div id="pages" data-testid="stampa-pagine">' + cover + '</div>' +
    '<script>window.__CFG=' + JSON.stringify(cfg) + ';(' + impaginaScript.toString() + ')();</script>' +
    '</body></html>';
};
